import {ForumI18n} from '@/locales/base.message.locales';

export const forum: ForumI18n = {
  actions: 'Ações',
  last_topic: 'Ultimo Tópico',
  replies: 'Respostas',
  search: 'Buscar',
  title: 'Forum',
  total: 'Total',
  message: {
    destroy: 'Remover Mensagem',
    edit: 'Editar Mensagem',
    edited: 'Editada',
    new: 'Nova Mensagem',
    empty_replies: 'Nenhuma resposta',
    reason_for_reporting: 'Motivo da denúncia...',
  },
  topic: {
    destroy: 'Remover Tópico',
    edit: 'Editar Tópico',
    last_post: 'Ultima Postagem por <span class="topic-author">{0}</span>',
    new: 'Novo Tópico',
    show: 'Mostrar Tópico',
    title: 'Topicos',
    report: 'Reportar',
  },
  dialog: {
    confirm_destroy: 'Tem certeza que deseja remover?'
  }
};
